import dayjs from "dayjs";

export const KANBAN_DATE_FILTER_STORAGE_KEY = "crm.leadsKanban.dateFilter";
export const LEADS_TABLE_DATE_FILTER_STORAGE_KEY = "crm.leadsTable.dateFilter";
// rangos rápidos (puedes ajustar labels / keys)
export const QUICK_RANGES = {
  today: { label: "Hoy" },
  last7: { label: "Últimos 7 días" },
  last30: { label: "Últimos 30 días" },
  last90: { label: "Últimos 3 meses" },
  last180: { label: "Últimos 6 meses" },
};




// Para “hasta todo el día”, backend lo hará con __date__lte (como te recomendé).
// Aquí solo mandamos YYYY-MM-DD.
export function formatYYYYMMDD(date) {
  return dayjs(date).format("YYYY-MM-DD");
}

export function computeQuickRange(key) {
  const today = dayjs(); // TZ del navegador
  const end = today;

  switch (key) {
    case "today":
      return { startDate: today.toDate(), endDate: today.toDate() };

    case "last7":
      return { startDate: today.subtract(6, "day").toDate(), endDate: end.toDate() };

    case "last30":
      return { startDate: today.subtract(29, "day").toDate(), endDate: end.toDate() };

    case "last90":
      return { startDate: today.subtract(89, "day").toDate(), endDate: end.toDate() };

    case "last180":
      return { startDate: today.subtract(179, "day").toDate(), endDate: end.toDate() };

    default:
      return { startDate: null, endDate: null };
  }
}

export function loadKanbanDateFilter() {
  try {
    const raw = localStorage.getItem(KANBAN_DATE_FILTER_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    return {
      activeRange: parsed?.activeRange ?? "last7",
      startDate: parsed?.startDate ? new Date(parsed.startDate) : null,
      endDate: parsed?.endDate ? new Date(parsed.endDate) : null,
    };
  } catch {
    return null;
  }
}

export function saveKanbanDateFilter({ activeRange, startDate, endDate }) {
  localStorage.setItem(
    KANBAN_DATE_FILTER_STORAGE_KEY,
    JSON.stringify({
      activeRange: activeRange ?? null,
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null,
    })
  );
}

export function buildKanbanParams(startDate, endDate) {
  const params = {};
  if (startDate) params.created_at_after = formatYYYYMMDD(startDate);
  if (endDate) params.created_at_before = formatYYYYMMDD(endDate);
  return params;
}


export function buildCreatedAtParams(startDate, endDate) {
  const params = {};
  if (startDate) params.created_at_after = formatYYYYMMDD(startDate);
  if (endDate) params.created_at_before = formatYYYYMMDD(endDate);
  return params;
}